var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-banner background--center",class:[
    _vm.contentItem.size,
    _vm.contentItem.white_content === true ? 'color--white' : ''
  ],style:(_vm.itemBackground)},[_c('div',{staticClass:"grid-x align-middle",class:_vm.contentItem.alignment === 'right' ? 'align-right' : ''},[_c('div',{staticClass:"cell content",class:_vm.contentItem.alignment === 'fullWidth' ? 'auto' : 'small-12 xlarge-7',domProps:{"innerHTML":_vm._s(_vm.contentItem.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }